import { CanDeactivateFn } from '@angular/router';
import { CreateTenantPageComponent } from './create-tenant-page.component';

export const createTenantUnsavedChangesGuard: CanDeactivateFn<CreateTenantPageComponent> = (component) =>
	component.requestDiscardChangesConfirmation();
